<template>
  <div>
    <div class="popupBlurBg" :class="{on: show, layer: isMultiplePopup}" @click.stop="onClickClose"></div>
    <section class="slidePopup" :class="{on: show, dark: blackGroundTheme, layer: isMultiplePopup}">
      <div class="topArea">
        <p>{{ t('skillCertify-candidate-info') }}</p>
        <div class="exit" @click.stop="onClickClose" />
      </div>
      <div class="action scrollY">
        <section id="dashSubBanner">
          <div class="dashSubBanner">
            <div class="userInfo" :class="{nonMember: isDeleteMember || isSampleMember}">
              <div class="profileImg" @click.stop="onClickProfile">
                <img v-if="isDeleteMember" src="~/assets/images/profile_default_img.svg" alt="">
                <img v-else :src="proSkillManagerTimeline.userInfo.profileImageUrl" alt="" @click.stop="onClickProfile"></div>
              <div class="rightArea" @click.stop="onClickProfile">
                <template v-if="isDeleteMember">
                  <h5>{{ t('common-delete-member') }}</h5>
                </template>
                <template v-else>
                  <h5>{{ proSkillManagerTimeline.userInfo.nickName }}</h5>
                  <span>{{ t('account-email') }}</span>
                  <p>{{ proSkillManagerTimeline.userInfo.email }}</p>
                </template>
              </div>
            </div>
          </div>
        </section>
        <ul class="tabMenu">
          <li class="active" >{{ t('skillCertify-action-timeline') }}</li>
        </ul>
        <div class="listTopArea">
          <div class="listCount"><span>{{ proSkillManagerTimeline.statusHistoryVOList.length }}</span>
            {{ t('skillCertify-action-record-count', proSkillManagerTimeline.statusHistoryVOList.length) }}
          </div>
        </div>
        <div class="statusWrap flex">
          <ul v-for="(timeline, index) in proSkillManagerTimeline.statusHistoryVOList" :key="index">
            <li class="status" :class="getTimelineStatusClass(timeline.status)">
              {{ getTimelineStatusString(timeline.status) }}
            </li>
            <li>{{ getTimelineStatusTextString(timeline.status, timeline.statusAt) }}</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useProSkillManagerService} from '~/composables/service/useProSkillManagerService';
import {convertTimeToLocalFormatString, getTimeZoneDateString} from '~/utils/CovertDateUtill';
import {useI18n} from 'vue-i18n';
import {
  ProSkillManagerTimelineModel
} from '~~/package/mapper/proSkillManager/model/actions/ProSkillManagerTimelineModel';
import {
  ProSkillManagerCandidateStatusType
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateStatusType';
import {UserStatusType} from '~~/package/mapper/user/model/UserStatusType';
import DialogType from '~/components/Common/Dialog/model/DialogType';

const { t } = useI18n();
const {$i18n} = useNuxtApp();
const dialogStore = useDialogStore();
const proSkillManagerService = useProSkillManagerService();
const proSkillManagerTimeline = ref<ProSkillManagerTimelineModel>(new ProSkillManagerTimelineModel());
const router = useRouter();
const show = ref(false);

const blackGroundTheme = ref(false);
const isMultiplePopup = ref(false);

onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      show.value = true
      blackGroundTheme.value = dialogStore.multiOption.find(option => option.type === DialogType.CandidateTimeLinePopup)?.props.theme;
      isMultiplePopup.value = dialogStore.multiOption.find(option => option.type === DialogType.CandidateTimeLinePopup)?.props.isMultiplePopup;
      getTimeline(
          dialogStore.multiOption.find(option => option.type === DialogType.CandidateTimeLinePopup)?.props.assessmentId,
          dialogStore.multiOption.find(option => option.type === DialogType.CandidateTimeLinePopup)?.props.userUUID
      );
    }, 10)
  })
})

const isSampleMember = computed(() => {
  return proSkillManagerTimeline.value.isSampleData;
})

const isDeleteMember = computed(() => {
  return proSkillManagerTimeline.value.userInfo.userStatus === UserStatusType.LEAVE
})

const getTimeline = (assessmentId: number, userUUID: string) => {
  proSkillManagerService.getProSkillManagerTimeline(assessmentId, userUUID).then(timelines => {
    proSkillManagerTimeline.value = timelines;
  })
}

const getTimelineStatusClass = (status: ProSkillManagerCandidateStatusType) => {
  const statusClasses: Record<ProSkillManagerCandidateStatusType, string> = {
    [ProSkillManagerCandidateStatusType.IN_PROGRESS]: "blue",
    [ProSkillManagerCandidateStatusType.READY]: "green",
    [ProSkillManagerCandidateStatusType.NOT_SHOW]: "red",
    [ProSkillManagerCandidateStatusType.INVITED]: "",
    [ProSkillManagerCandidateStatusType.COMPLETED]: "",
  };
  return statusClasses[status] || "";
};

const getTimelineStatusString = (status: ProSkillManagerCandidateStatusType) => {
  const statusStrings: Record<ProSkillManagerCandidateStatusType, string> = {
    [ProSkillManagerCandidateStatusType.IN_PROGRESS]: t('skillCertify-started'),
    [ProSkillManagerCandidateStatusType.READY]: t('skillCertify-ready'),
    [ProSkillManagerCandidateStatusType.INVITED]: t('skillCertify-invited'),
    [ProSkillManagerCandidateStatusType.COMPLETED]: t('skillCertify-completed'),
  };
  return statusStrings[status] || "";
};

const getTimelineStatusTextString = (status: ProSkillManagerCandidateStatusType, statusTime: string | null) => {
  if (!statusTime) return "-";
  const statusStrings: Record<ProSkillManagerCandidateStatusType, string> = {
    [ProSkillManagerCandidateStatusType.IN_PROGRESS]: t('skillCertify-candidate-started-date'),
    [ProSkillManagerCandidateStatusType.READY]: t('skillCertify-candidate-ready-date'),
    [ProSkillManagerCandidateStatusType.INVITED]: t('skillCertify-candidate-invited-date'),
    [ProSkillManagerCandidateStatusType.COMPLETED]: t('skillCertify-candidate-completed-date'),
  };
  const statusAt = getTimeZoneDateString(statusTime)
  return (statusStrings[status]+" " || "") + convertTimeToLocalFormatString(statusAt, $i18n.locale.value);
};

const onClickProfile = () => {
  if(isDeleteMember.value || isSampleMember.value) return;
  onClickClose();
  router.push({path: '/profile', query: { uuid: dialogStore.multiOption.find(option => option.type === DialogType.CandidateTimeLinePopup)?.props.userUUID }})
}

const onClickClose = () => {
  show.value = false
  setTimeout(() => {
    dialogStore.deleteMultiOption({
      type: DialogType.CandidateTimeLinePopup
    })
  }, 200);
}
</script>
